module.exports = __webpack_public_path__ + "static/apple-store-light-b48ee42e9f5eabe0b4f2f1abd5b7e5f5.svg";